import { writable, type Writable } from 'svelte/store';

export type AuthRole = 'ADMIN' | 'ANALYST' | 'READER';

export interface SessionUser {
  id: string;
  email: string;
  role: AuthRole;
}

/** Current logged-in user (or null when no session). */
export const session: Writable<SessionUser | null> = writable(null);

export function setSession(user: SessionUser): void {
  session.set(user);
}

export function clearSession(): void {
  session.set(null);
}
